'use es6';

import I18n from 'I18n';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import SearchQueryRecord from 'SalesContentIndexUI/data/records/SearchQueryRecord';
import SearchResultRecord from 'SalesContentIndexUI/data/records/SearchResultRecord';
import { trackModalIndexInteraction } from 'SalesContentIndexUI/utils/UsageLogger';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { FilterBar } from 'foundations-components/transitional/components/FilterBar';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import IndexTableViewFilters from './IndexTableViewFilters';
import IndexTableBreadcrumbs from './IndexTableBreadcrumbs';
import NewFolderButton from './header/newFolder/NewFolderButton';
import SearchContentTypes from 'SalesContentIndexUI/data/constants/SearchContentTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CreateTemplateButton = ({
  onClickNew,
  looseItemContentType
}) => {
  const handleClick = () => {
    trackModalIndexInteraction(looseItemContentType, 'create-new-template');
    onClickNew();
  };
  return /*#__PURE__*/_jsx(Button, {
    use: "primary",
    onClick: handleClick,
    marginInlineEnd: "400",
    "data-test-id": "create-template-button",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "salesContentIndexUI.contentModal.createButton.template"
    })
  });
};
CreateTemplateButton.propTypes = {
  onClickNew: PropTypes.func.isRequired,
  looseItemContentType: PropTypes.string.isRequired
};
const getSearchPlaceholder = ({
  selectedFolder,
  looseItemContentType
}) => {
  return selectedFolder ? I18n.text('salesContentIndexUI.search.folder') : I18n.text(`salesContentIndexUI.search.contentTypes.${looseItemContentType}`);
};
const IndexTableNavigator = ({
  searchQuery,
  selectedViewFilterId,
  setViewFilter,
  setSearchQuery,
  selectedFolder,
  setSelectedFolder,
  looseItemContentType,
  useOwnerViewFilters,
  location,
  saveFolder,
  showNewFolderButton,
  onClickNew,
  showTemplateCreateButton
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(IndexTableBreadcrumbs, {
      selectedFolder: selectedFolder,
      setSelectedFolder: setSelectedFolder
    }), /*#__PURE__*/_jsx(FilterBar, {
      startSlot: /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(FormControl, {
          "aria-label": I18n.text('salesContentIndexUI.search.form'),
          children: /*#__PURE__*/_jsx(SearchInput, {
            "data-test-id": "sales-modal-search-input",
            value: searchQuery.query,
            placeholder: getSearchPlaceholder({
              selectedFolder,
              looseItemContentType
            }),
            onChange: ({
              target: {
                value
              }
            }) => setSearchQuery(value)
          })
        }), /*#__PURE__*/_jsx(IndexTableViewFilters, {
          selectedViewFilterId: selectedViewFilterId,
          setViewFilter: setViewFilter,
          looseItemContentType: looseItemContentType,
          useOwnerViewFilters: useOwnerViewFilters
        })]
      }),
      endSlot: /*#__PURE__*/_jsxs(_Fragment, {
        children: [showNewFolderButton && /*#__PURE__*/_jsx(NewFolderButton, {
          saveFolder: saveFolder,
          location: location,
          use: "tertiary-light"
        }), showTemplateCreateButton && looseItemContentType === SearchContentTypes.TEMPLATE && /*#__PURE__*/_jsx(CreateTemplateButton, {
          onClickNew: onClickNew,
          looseItemContentType: looseItemContentType
        })]
      }),
      marginBlockStart: "0",
      marginInlineStart: "600"
    })]
  });
};
IndexTableNavigator.propTypes = {
  searchQuery: PropTypes.instanceOf(SearchQueryRecord).isRequired,
  selectedViewFilterId: PropTypes.string.isRequired,
  selectedFolder: PropTypes.instanceOf(SearchResultRecord),
  setSearchQuery: PropTypes.func.isRequired,
  setSelectedFolder: PropTypes.func.isRequired,
  setViewFilter: PropTypes.func.isRequired,
  isModal: PropTypes.bool.isRequired,
  looseItemContentType: PropTypes.string.isRequired,
  useOwnerViewFilters: PropTypes.bool,
  location: PropTypes.object,
  saveFolder: PropTypes.func,
  showNewFolderButton: PropTypes.bool,
  onClickNew: PropTypes.func,
  showTemplateCreateButton: PropTypes.bool
};
export default IndexTableNavigator;